import { useEffect } from 'react';
import { getApiBaseUrl } from './config';

export const getSessionId = () => {
    if (typeof window === 'undefined') return undefined;
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
        sessionId = typeof crypto !== 'undefined' && crypto.randomUUID 
            ? crypto.randomUUID() 
            : Math.random().toString(36).substring(2) + Date.now().toString(36);
        sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
};

export const trackEvent = (eventName: string, data: Record<string, any> = {}) => {
    try {
        const payload = {
            event_name: eventName,
            session_id: getSessionId(),
            page: data.page || (typeof window !== 'undefined' ? window.location.pathname : undefined),
            tool: data.tool,
            country: data.country, 
            device: data.device || (typeof window !== 'undefined' ? (window.innerWidth < 768 ? 'mobile' : 'desktop') : undefined),
            browser: data.browser, 
            traffic_source: data.traffic_source || (typeof document !== 'undefined' ? (document.referrer || undefined) : undefined),
            metadata_json: data.metadata || {},
        };

        const backendUrl = getApiBaseUrl();
        fetch(`${backendUrl}/api/analytics/event`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
            keepalive: true
        }).catch(() => { /* silent fail */ });
    } catch (e) {
        // silent fail
    }
};

export const useAnalytics = (toolName: string) => {
    useEffect(() => {
        // Log tool_view when entering tool UI
        trackEvent('tool_view', { tool: toolName });
    }, [toolName]);
};
